import styled from "@emotion/styled"

import { gray800 } from "@nvdb-rapport/shared/src/color"

export const Heading1 = styled.h1`
  font-family: LFT Etica Semibold;
  font-size: 22px;
  line-height: 32px;
  margin: 2rem 0;
  color: ${gray800};
`

export const Heading2 = styled.h2`
  font-family: LFT Etica Semibold;
  font-size: 18px;
  line-height: 32px;
  margin: 2rem 0;
  color: ${gray800};
  text-align: center;
`
